import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ErrorBoundary from 'components/ErrorBoundary'
import { connect } from 'react-redux'
import { ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'
import Select from 'react-select'
import AutoTable from 'components/AutoTable'
import Checkbox from 'components/Checkbox'
import _flatMap from 'lodash/flatMap'
import { bindActionCreators } from 'redux'
import lmsOperations from 'store/css-admin/lmsManager/operations'
import * as notificationActionCreators from 'store/notifications'

export class EditTrainingModal extends Component {
  static propTypes = {
    activeSkuCode: PropTypes.string,
    childModuleProgress: PropTypes.object,
    clearChildModuleStatus: PropTypes.func,
    closeModal: PropTypes.func,
    cssLmsTrainingStatus: PropTypes.array,
    currentTrainingTrack: PropTypes.array,
    isSavingTraining: PropTypes.bool.isRequired,
    savingTraining: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)
    const { checkedChildModules } = this.childTracks(props)
    this.state = {
      isChecked: false,
      selectedTraining: this.setTrainingPath(props),
      checkedItems: checkedChildModules,
    }
  }

  addTrainingPath = async () => {
    const { props, state } = this
    props.savingTraining(true)
    try {
      const { programInstance } = await props.addTraining(
        props.userEmail,
        props.activeSkuCode,
        state.selectedTraining.value,
        props.userId,
      )
      await props.fetchChildModuleStatus(
        props.userEmail,
        state.selectedTraining.value,
        props.activeSkuCode,
      )
      await props.fetchTrainingStatusesCss(props.userEmail)
      const { checkedChildModules } = this.childTracks(this.props)
      this.setState({ checkedItems: checkedChildModules })
      props.savingTraining(false)
    } catch (e) {
      props.savingTraining(false)
    }
  }

  childTracks = args => {
    const checkedChildModules = new Map()
    if (args.childModuleProgress[args.activeSkuCode].length > 0) {
      args.childModuleProgress[args.activeSkuCode].map(module => {
        const isChecked = module.status === 'Completed'
        checkedChildModules.set(module.sco, isChecked)
      })
    }

    const selectedChildRows =
      args.childModuleProgress[args.activeSkuCode].length > 0 &&
      args.childModuleProgress[args.activeSkuCode].map(track => ({
        label: track.title,
        value: track.sco,
      }))

    return {
      selectedChildRows,
      checkedChildModules,
    }
  }

  getChildModuleStatus = scoId => {
    // returns the child module status
    const { props } = this
    const childModule = props.childModuleProgress[props.activeSkuCode].find(
      x => x.sco === scoId,
    )
    return childModule.status
  }

  getUsersActivePath = () =>
    this.props.currentTrainingTrack.find(
      path => path.program === this.props.activeSkuCode,
    )

  handleTrainingChange = async selectedTraining => {
    const { props } = this
    props.clearChildModuleStatus(props.activeSkuCode)
    this.setState({
      selectedTraining,
      isChecked: false,
    })
  }

  handleOnCheck = e => {
    const trainingId = parseInt(e.target.id.split('-')[1], 10)
    const isChecked = e.target.checked
    const checkedItems = new Map(this.state.checkedItems)
    checkedItems.set(trainingId, isChecked)
    this.setState({ checkedItems })
  }

  setTrainingPath = props => {
    const [track] = this.trainingTrack(
      props.currentTrainingTrack,
      props.activeSkuCode,
    )
    if (track.users_current_track) {
      return {
        value: track.users_current_track.id,
        label: track.users_current_track.title,
      }
    }
    return []
  }

  //Function that takes in an array of training info and returns the matched track based on the edit modal selected
  trainingTrack = (trainingTrack, skuCode) =>
    trainingTrack.filter(training => training.program === skuCode)

  updateTrainingPath = async () => {
    const { props, state } = this

    const activeTrack = props.currentTrainingTrack.find(
      track => track.program === props.activeSkuCode,
    )
    const childIds = []
    state.checkedItems.forEach((value, key) => {
      if (value) {
        childIds.push(key)
      }
    })
    props.savingTraining(true)
    try {
      await props.updateTraining(
        props.userEmail,
        state.selectedTraining.value,
        childIds,
        activeTrack.users_current_track.instance,
      )
      props.addNotification({
        color: 'success',
        text: "Successfully updated user's training status.",
      })
      await props.fetchTrainingStatusesCss(props.userEmail)
      props.savingTraining(false)
    } catch (e) {
      props.addNotification({
        color: 'danger',
        text: "Failed updating user's training status. Please try again later.",
      })
      props.savingTraining(false)
    }
    props.closeModal()
    this.setState({ isChecked: false })
  }

  filteredTraining = args => {
    const track = this.trainingTrack(
      args.cssLmsTrainingInfo,
      args.activeSkuCode,
    )
    return _flatMap(track, x =>
      x.possible_tracks.map(track => ({
        label: track.track_title,
        value: track.track_id,
      })),
    )
  }

  // AUTO TABLE COLUMN DATA
  trainingStatusColumns = [
    { title: 'Name', fieldValue: 'label' },
    {
      title: 'Module Status',
      fieldValue: item => {
        return this.getChildModuleStatus(item.value)
      },
    },
    {
      title: 'Complete',
      headerClassName: 'css-admin-training-modal th-padding-left',
      cellClassName: 'text-center',
      fieldValue: item => {
        return (
          <Checkbox
            checked={this.state.checkedItems.get(item.value)}
            disabled={
              this.getChildModuleStatus(item.value) === 'Completed' &&
              this.state.checkedItems.get(item.value)
            }
            id={`scoId-${item.value}`}
            name={item.label}
            onChange={e => this.handleOnCheck(e)}
          />
        )
      },
    },
  ]

  render = () => {
    const { props, state } = this
    const { selectedChildRows } = this.childTracks(props)
    const isEditing = this.getUsersActivePath().users_current_track
    return (
      <ErrorBoundary>
        {!isEditing && (
          <ModalHeader
            toggle={props.closeModal}
          >{`Add ${props.activeSkuCode.toUpperCase()} Training`}</ModalHeader>
        )}
        {isEditing && (
          <ModalHeader
            toggle={props.closeModal}
          >{`Edit ${props.activeSkuCode.toUpperCase()}  Training`}</ModalHeader>
        )}
        <ModalBody>
          Training Name/Path
          <Select
            className="flex-grow-1"
            onChange={this.handleTrainingChange}
            options={this.filteredTraining(props)}
            value={state.selectedTraining}
          />
          <br />
          {props.childModuleProgress[props.activeSkuCode].length > 0 && (
            <div className="form-group">
              <AutoTable
                borderless
                columns={this.trainingStatusColumns}
                headThemeLight
                rowClassName={'css-admin-tr-border-bottom'}
                rows={selectedChildRows || []}
              />
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={props.closeModal}
            role="button"
            size="sm"
          >
            Cancel
          </Button>
          {props.childModuleProgress[props.activeSkuCode].length === 0 && (
            <Button
              color="primary"
              disabled={
                state.selectedTraining.length === 0 || props.isSavingTraining
              }
              onClick={this.addTrainingPath}
              role="button"
              size="sm"
            >
              {props.isSavingTraining ? (
                <React.Fragment>
                  <i className="fa fa-spinner fa-spin" />
                  &nbsp;Saving...
                </React.Fragment>
              ) : (
                <React.Fragment>{`${
                  isEditing ? 'Save' : 'Add'
                }`}</React.Fragment>
              )}
            </Button>
          )}
          {props.childModuleProgress[props.activeSkuCode].length > 0 && (
            <Button
              color="primary"
              disabled={
                state.selectedTraining.length === 0 || props.isSavingTraining
              }
              onClick={this.updateTrainingPath}
              role="button"
              size="sm"
            >
              {props.isSavingTraining ? (
                <React.Fragment>
                  <i className="fa fa-spinner fa-spin" />
                  &nbsp;Saving...
                </React.Fragment>
              ) : (
                <React.Fragment>Save</React.Fragment>
              )}
            </Button>
          )}
        </ModalFooter>
      </ErrorBoundary>
    )
  }
}

const mapStateToProps = ({ lmsManager, userManager }) => ({
  activeSkuCode: lmsManager.activeSkuCode,
  childModuleProgress: lmsManager.childModuleProgress,
  cssLmsTrainingInfo: lmsManager.all_training_info,
  currentTrainingTrack: lmsManager.training_track,
  isSavingTraining: lmsManager.isSavingTraining,
  userEmail: userManager.productUser.email,
  userId: userManager.productUser.id,
})
const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      ...lmsOperations,
      ...notificationActionCreators,
    },
    dispatch,
  )
}
export default connect(mapStateToProps, mapDispatchToProps)(EditTrainingModal)
